import { AppState } from '../store';

// eslint-disable-next-line import/prefer-default-export
export const selectSnackbars = (state: AppState) => state.snackbars;
